module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-down-right-square-fill-45f08671.svg";